(function () {
  'use strict';

  var API_BASE = 'https://api.reviews.io/product/review/new?store=';

  function parseConfig(scriptEl) {
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      var data = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (parseErr) {
          data = {};
        }
      }
      return { ok: res.ok, data: data };
    });
  }

  function getApiErrorMessage(data, genericFallback) {
    if (data && typeof data.message === 'string' && data.message) return data.message;
    if (data && Array.isArray(data.errors) && data.errors.length) return data.errors.join(' ');
    return genericFallback;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** HTML for dropdown rows (innerHTML). Escapes user data. */
  function formatSkuLine(sku, title) {
    return (
      '<span class="reviews-hub__sku-line">' +
      '<span class="reviews-hub__sku-code">' +
      escapeHtml(String(sku)) +
      '</span>' +
      ' <span class="reviews-hub__sku-sep" aria-hidden="true">|</span> ' +
      '<span class="reviews-hub__sku-title">' +
      escapeHtml(title || '') +
      '</span>' +
      '</span>'
    );
  }

  /** Plain text for the search input and lastCommittedLine (input cannot render HTML). */
  function formatSkuLinePlain(sku, title) {
    return String(sku) + ' | ' + (title || '');
  }

  function initHub(section) {
    if (section.dataset.reviewsHubFormInit) return;
    var cfgEl = section.querySelector('script.reviews-hub__config[type="application/json"]');
    var cfg = parseConfig(cfgEl);
    if (!cfg || !cfg.store) return;

    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;
    
    var messages = cfg.messages || {};
    var form = document.getElementById('ReviewsHubForm--' + sectionId);
    var msgEl = document.getElementById('ReviewsHubMessage--' + sectionId);
    var skuField = section.querySelector('[data-reviews-hub-sku]');
    var skuDataScript = skuField ? skuField.querySelector('script[data-reviews-hub-sku-data]') : null;
    var skuHidden = skuField ? skuField.querySelector('input[name="sku"]') : null;
    var skuSearch = skuField ? skuField.querySelector('[data-reviews-hub-sku-search]') : null;
    var skuList = skuField ? skuField.querySelector('[data-reviews-hub-sku-list]') : null;
    if (!form || !msgEl || !skuField || !skuHidden || !skuSearch || !skuList) return;
    
    const params = new URLSearchParams(window.location.search);
    const psku = params.get('psku');
  
    if (psku && skuSearch) {
      skuSearch.value = psku;
    }

    var skuRows = [];
    if (skuDataScript && skuDataScript.textContent) {
      try {
        var parsed = JSON.parse(skuDataScript.textContent);
        if (Array.isArray(parsed)) skuRows = parsed;
      } catch (err) {
        skuRows = [];
      }
    }
    var selectedProductTitle = '';
    var lastCommittedLine = '';

    var nameInput = form.querySelector('#ReviewsHubName--' + sectionId);
    var emailInput = form.querySelector('#ReviewsHubEmail--' + sectionId);
    var postcodeInput = form.querySelector('#ReviewsHubPostcode--' + sectionId);
    var feedbackInput = form.querySelector('#ReviewsHubFeedback--' + sectionId);
    var ratingFieldset = form.querySelector('fieldset[data-reviews-hub-rating]');

    if (!nameInput || !emailInput || !postcodeInput || !feedbackInput || !ratingFieldset) return;

    section.dataset.reviewsHubFormInit = '1';

    var apiUrl = API_BASE + encodeURIComponent(cfg.store);

    var fieldErrorIds = {
      sku: 'ReviewsHubFieldError--' + sectionId + '-sku',
      name: 'ReviewsHubFieldError--' + sectionId + '-name',
      email: 'ReviewsHubFieldError--' + sectionId + '-email',
      postcode: 'ReviewsHubFieldError--' + sectionId + '-postcode',
      rating: 'ReviewsHubFieldError--' + sectionId + '-rating',
      feedback: 'ReviewsHubFieldError--' + sectionId + '-feedback'
    };

    var textFieldEls = {
      name: nameInput,
      email: emailInput,
      postcode: postcodeInput,
      feedback: feedbackInput
    };

    function isValidEmail(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
    }

    function setMessage(text, kind) {
      msgEl.textContent = text || '';
      msgEl.hidden = !text;
      msgEl.className = 'reviews-hub__form-message' + (kind ? ' reviews-hub__form-message--' + kind : '');
    }

    function getErrorEl(key) {
      var id = fieldErrorIds[key];
      return id ? document.getElementById(id) : null;
    }

    function getCheckedRating() {
      var r = form.querySelector('input[name="rating"]:checked');
      return r ? parseInt(r.value, 10) : NaN;
    }

    function getFormState() {
      return {
        sku: (skuHidden.value || '').trim(),
        name: (nameInput.value || '').trim(),
        email: (emailInput.value || '').trim(),
        postcode: (postcodeInput.value || '').trim(),
        reviewBody: (feedbackInput.value || '').trim(),
        rating: getCheckedRating()
      };
    }

    function setFieldError(key, text) {
      var errEl = getErrorEl(key);
      if (errEl) {
        errEl.textContent = text;
        errEl.hidden = !text;
      }
      if (key === 'sku' && skuSearch) {
        skuSearch.classList.toggle('field--error', !!text);
        skuSearch.setAttribute('aria-invalid', text ? 'true' : 'false');
        return;
      }
      if (key === 'rating' && ratingFieldset) {
        ratingFieldset.classList.toggle('reviews-hub__fieldset--error', !!text);
        var ratingRadios = ratingFieldset.querySelectorAll('input[name="rating"]');
        for (var ri = 0; ri < ratingRadios.length; ri++) {
          if (text) {
            ratingRadios[ri].setAttribute('aria-invalid', 'true');
          } else {
            ratingRadios[ri].removeAttribute('aria-invalid');
          }
        }
        return;
      }
      var el = textFieldEls[key];
      if (el) {
        el.classList.toggle('field--error', !!text);
        el.setAttribute('aria-invalid', text ? 'true' : 'false');
      }
    }

    function clearFieldError(key) {
      setFieldError(key, '');
    }

    function clearAllFieldErrors() {
      clearFieldError('sku');
      clearFieldError('name');
      clearFieldError('email');
      clearFieldError('postcode');
      clearFieldError('rating');
      clearFieldError('feedback');
    }

    function getSelectedProductTitle() {
      return selectedProductTitle || '';
    }

    function setListExpanded(on) {
      skuSearch.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function closeSkuList() {
      skuList.innerHTML = '';
      skuList.hidden = true;
      setListExpanded(false);
    }

    function clearSkuSelection() {
      skuHidden.value = '';
      selectedProductTitle = '';
      lastCommittedLine = '';
    }

    function onSkuSearchInput() {
      var q = (skuSearch.value || '').trim();
      if (skuSearch.value !== lastCommittedLine) {
        clearSkuSelection();
      }
      if (!q) {
        closeSkuList();
        return;
      }
      var qLower = q.toLowerCase();
      var matches = [];
      for (var i = 0; i < skuRows.length; i++) {
        var row = skuRows[i];
        if (!row) continue;
        var sk = String(row.sku);
        if (sk.toLowerCase().indexOf(qLower) === -1) continue;
        matches.push(row);
      }
      skuList.innerHTML = '';
      if (matches.length === 0) {
        var liEmpty = document.createElement('li');
        liEmpty.setAttribute('role', 'presentation');
        liEmpty.style.padding = '0.5rem 0.75rem';
        liEmpty.style.fontSize = '0.875rem';
        liEmpty.style.opacity = '0.8';
        liEmpty.textContent = 'No product matches that SKU.';
        skuList.appendChild(liEmpty);
        skuList.hidden = false;
        setListExpanded(true);
        return;
      }
      for (var j = 0; j < matches.length; j++) {
        var m = matches[j];
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.innerHTML = formatSkuLine(m.sku, m.title);
        btn.setAttribute('data-sku', String(m.sku));
        btn.setAttribute('data-title', m.title == null ? '' : String(m.title));
        li.appendChild(btn);
        skuList.appendChild(li);
      }
      skuList.hidden = false;
      setListExpanded(true);
    }

    var skuInputTimer = null;
    function scheduleSkuFilter() {
      if (skuInputTimer) {
        clearTimeout(skuInputTimer);
      }
      skuInputTimer = setTimeout(function () {
        skuInputTimer = null;
        onSkuSearchInput();
      }, 180);
    }

    skuList.addEventListener('mousedown', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[data-sku]') : null;
      if (!btn) return;
      e.preventDefault();
      var sk = (btn.getAttribute('data-sku') || '').trim();
      var tl = btn.getAttribute('data-title') || '';
      if (!sk) return;
      skuHidden.value = sk;
      selectedProductTitle = tl;
      var line = formatSkuLinePlain(sk, tl);
      skuSearch.value = line;
      lastCommittedLine = line;
      clearFieldError('sku');
      closeSkuList();
    });

    document.addEventListener('click', function (e) {
      if (!skuField.contains(e.target)) closeSkuList();
    });

    function resetSkuComboboxAfterFormReset() {
      clearSkuSelection();
      lastCommittedLine = '';
      closeSkuList();
    }

    function runValidation() {
      clearAllFieldErrors();
      var s = getFormState();
      var ok = true;
      if (!s.sku) {
        setFieldError('sku', 'Search by SKU and choose a product.');
        ok = false;
      }
      if (!s.name) {
        setFieldError('name', 'Please enter your name.');
        ok = false;
      }
      if (!s.email) {
        setFieldError('email', 'Please enter your email address.');
        ok = false;
      } else if (!isValidEmail(s.email)) {
        setFieldError('email', 'Please enter a valid email address.');
        ok = false;
      }
      if (!s.postcode) {
        setFieldError('postcode', 'Please enter your postcode.');
        ok = false;
      }
      if (isNaN(s.rating) || s.rating < 1 || s.rating > 5) {
        setFieldError('rating', 'Please choose a star rating.');
        ok = false;
      }
      if (!s.reviewBody) {
        setFieldError('feedback', 'Please enter your feedback.');
        ok = false;
      }
      return { ok: ok, state: s };
    }

    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t === nameInput) clearFieldError('name');
      if (t === emailInput) clearFieldError('email');
      if (t === postcodeInput) clearFieldError('postcode');
      if (t === feedbackInput) clearFieldError('feedback');
      if (t === skuSearch) {
        clearFieldError('sku');
        scheduleSkuFilter();
      }
    });

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'rating') clearFieldError('rating');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setMessage('', null);

      var v = runValidation();
      if (!v.ok) {
        setMessage(messages.validation || 'Please check the highlighted fields and try again.', 'error');
        return;
      }

      var s = v.state;
      var productTitle = getSelectedProductTitle();
      var reviewText = s.reviewBody;
      if (productTitle) {
        reviewText = 'Product: ' + productTitle + '\n\n' + s.reviewBody;
      }

      var payload = {
        sku: s.sku,
        name: s.name,
        email: s.email,
        review: reviewText,
        rating: s.rating
      };
      if (s.postcode) payload.address = s.postcode;

      form.classList.add('is-submitting');

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(parseJsonResponse)
        .then(function (result) {
          var data = result.data || {};
          if (data.success === true) {
            setMessage(messages.success, 'success');
            form.reset();
            resetSkuComboboxAfterFormReset();
            clearAllFieldErrors();
            if (cfg.autofill && typeof cfg.autofill === 'object') {
              if (cfg.autofill.name) nameInput.value = cfg.autofill.name;
              if (cfg.autofill.email) emailInput.value = cfg.autofill.email;
              if (cfg.autofill.postcode) postcodeInput.value = cfg.autofill.postcode;
            }
            return;
          }
          setMessage(getApiErrorMessage(data, messages.genericError), 'error');
        })
        .catch(function () {
          setMessage(messages.networkError, 'error');
        })
        .finally(function () {
          form.classList.remove('is-submitting');
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="page-reviews-hub"]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
